import { lazy, Suspense } from 'react';
import { useCanvasActivity } from '../hooks/useCanvasActivity';

/**
 * three.js and drei are ~880kB. Keeping the scene behind a lazy boundary that
 * only renders once the canvas is genuinely wanted means the chunk is never
 * fetched during page load.
 */
const PetScene = lazy(() =>
  import('./PetScene').then((module) => ({ default: module.PetScene })),
);

export function PetCanvas({
  scrollProgress = 0,
  className = '',
  compact = false,
  hero = false,
  overlay = false,
  pointerEnabled = true,
  textureSrc,
}: Props) {
  const { containerRef, active, onScreen, dpr, antialias } = useCanvasActivity<HTMLDivElement>();

  return (
    <div ref={containerRef} className={`absolute inset-0 ${className}`} aria-hidden="true">
      {active ? (
        <Suspense fallback={null}>
          <PetScene
            scrollProgress={scrollProgress}
            compact={compact}
            hero={hero}
            overlay={overlay}
            pointerEnabled={pointerEnabled}
            textureSrc={textureSrc}
            dpr={dpr}
            antialias={antialias}
            onScreen={onScreen}
          />
        </Suspense>
      ) : null}
    </div>
  );
}

interface Props {
  scrollProgress?: number;
  className?: string;
  compact?: boolean;
  hero?: boolean;
  overlay?: boolean;
  pointerEnabled?: boolean;
  textureSrc?: string;
}
